import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "motion/react";
import { AmbientBackground } from "./components/AmbientBackground";
import { SiteFooter } from "./components/SiteFooter";
import { SiteHeader } from "./components/SiteHeader";
import { TargetCursor } from "./components/TargetCursor";
import { routeMetadata } from "./content/siteContent";
import { AboutPage } from "./pages/AboutPage";
import { ContactPage } from "./pages/ContactPage";
import { FaqPage } from "./pages/FaqPage";
import { HomePage } from "./pages/HomePage";
import { LocationsPage } from "./pages/LocationsPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { TrainersPage } from "./pages/TrainersPage";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

function RouteEffects() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    const path = location.pathname.replace(/\/+$/, "") || "/";
    const metadata = routeMetadata[path] ?? routeMetadata["/"];
    document.title = metadata.title;
    const description = document.querySelector('meta[name="description"]');
    description?.setAttribute("content", metadata.description);
    window.gtag?.("event", "page_view", {
      page_path: `${location.pathname}${location.search}`,
      page_title: metadata.title,
    });
  }, [location.pathname, location.search]);

  return null;
}

export default function App() {
  const location = useLocation();

  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        Μετάβαση στο περιεχόμενο
      </a>
      <RouteEffects />
      <TargetCursor />
      <SiteHeader />
      <AmbientBackground />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<HomePage />} />
          <Route path="/o-syllogos" element={<AboutPage />} />
          <Route path="/topothesies" element={<LocationsPage />} />
          <Route path="/ekpaideftes" element={<TrainersPage />} />
          <Route path="/erotiseis" element={<FaqPage />} />
          <Route path="/epikoinonia" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AnimatePresence>
      <SiteFooter />
    </div>
  );
}
